import React, { createContext, useContext } from "react";
import { getMrqData, getMrqs } from "../../api";
import { getHashdata } from "../../../../../../../../components/Tabs/Utils/hashFunctions";
import { ifMrqUrl } from "./ifMrqUrl";
import { useMcsContext } from "../../../MCS.context";

const MrqContext = createContext();
export const useMrqContext = () => useContext(MrqContext);

function MrqContextProvider({ children }) {
  const { plant, setSelectedMrqData, mrqList, setMrqList } = useMcsContext();

  const mrqData = plant.selectedMrq;

  const [mrqSelection, setMrqSelection] = React.useState({
    selectedMrq: "",
    revisions: [],
    selectedRevision: "",
  });

  const [openAddPoModal, setOpenAddPoModal] = React.useState(false);

  const mrqId = getHashdata(window.location.hash, "mrq-id");

  React.useEffect(() => {
    const showMrqByUrl = async () => {
      mrqId &&
        (await ifMrqUrl({
          mrqId,
          setSelectedMrqData,
          setMrqSelection,
        }));
    };

    showMrqByUrl();
  }, [mrqId]);

  React.useEffect(() => {
    const fetchMrqList = async () => {
      await getMrqs({ plantId: plant.id }).then((res) => setMrqList(res));
    };

    fetchMrqList();
  }, []);

  // React.useEffect(() => {
  //   const revisions = mrqData?.revs ? mrqData.revs : [];

  //   setMrqSelection({
  //     selectedMrq: mrqData?.id,
  //     revisions,
  //     selectedRevision: mrqData?.id,
  //   });
  // }, [mrqData?.id]);

  React.useEffect(() => {
    // console.log({ mrqSelection });
    const fetchMrqThenBidData = async () => {
      if (mrqSelection.selectedMrq) {
        const mrq = await getMrqData(
          mrqSelection.selectedRevision || mrqSelection.selectedMrq,
        );

        setSelectedMrqData(mrq);
      }
    };

    fetchMrqThenBidData();
  }, [mrqSelection.selectedRevision, mrqSelection.selectedMrq]);

  return (
    <MrqContext.Provider
      value={{
        plant,

        mrqList,
        setMrqList,
        mrqSelection,
        setMrqSelection,
        mrqData,

        openAddPoModal,
        setOpenAddPoModal,
      }}
    >
      {children}
    </MrqContext.Provider>
  );
}
export { MrqContextProvider, MrqContext };
